import { useTranslation } from 'react-i18next';

const packages = [
  {
    key: 'basic',
    color: 'bg-secondary-100',
    accent: 'text-secondary-700',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20beauty%20treatment%20room%20with%20soft%20natural%20daylight%20streaming%20through%20large%20windows%2C%20minimalist%20white%20interior%20with%20subtle%20warm%20beige%20tones%2C%20professional%20treatment%20bed%20with%20crisp%20white%20linens%2C%20small%20wooden%20side%20table%20with%20organic%20skincare%20bottles%2C%20potted%20green%20plant%20in%20ceramic%20vase%2C%20calm%20serene%20atmosphere%2C%20no%20text%20no%20logos%20no%20labels%2C%20editorial%20photography%20style%20with%20soft%20shadows&width=600&height=500&seq=pkg-essential-v2&orientation=portrait',
  },
  {
    key: 'premium',
    color: 'bg-primary-100',
    accent: 'text-primary-700',
    image: 'https://readdy.ai/api/search-image?query=Premium%20aesthetic%20clinic%20treatment%20suite%20with%20professional%20overhead%20track%20lighting%2C%20high-end%20medical%20equipment%20with%20polished%20metallic%20finishes%2C%20glossy%20white%20countertops%20with%20subtle%20reflections%2C%20lush%20monstera%20plant%20in%20elegant%20ceramic%20pot%2C%20warm%20cream%20and%20beige%20walls%2C%20clean%20professional%20healthcare%20interior%20design%2C%20no%20text%20no%20logos%20no%20labels%2C%20realistic%20editorial%20photography&width=600&height=500&seq=pkg-premium-v2&orientation=portrait',
  },
  {
    key: 'luxe',
    color: 'bg-accent-100',
    accent: 'text-accent-700',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20high-end%20clinic%20room%20with%20natural%20daylight%20filtering%20through%20cream%20linen%20curtains%2C%20elegant%20cognac%20leather%20treatment%20chair%20with%20natural%20grain%20texture%2C%20dove%20gray%20walls%20with%20soft%20warm%20undertones%2C%20professional%20aesthetic%20devices%20with%20sleek%20industrial%20design%2C%20marble%20accent%20table%2C%20calm%20sophisticated%20atmosphere%2C%20no%20text%20no%20logos%20no%20labels%2C%20editorial%20photography%20with%20soft%20diffused%20lighting&width=600&height=500&seq=pkg-luxe-v2&orientation=portrait',
  },
  {
    key: 'exclusive',
    color: 'bg-secondary-200',
    accent: 'text-secondary-800',
    image: 'https://readdy.ai/api/search-image?query=Exclusive%20VIP%20beauty%20suite%20with%20fresh%20white%20peonies%20in%20crystal%20vase%20on%20marble%20side%20table%2C%20soft%20natural%20daylight%20from%20floor%20to%20ceiling%20windows%20creating%20gentle%20shadows%2C%20premium%20velvet%20furnishings%20in%20warm%20neutral%20tones%2C%20gold%20accent%20details%2C%20elegant%20mirrors%20with%20subtle%20frames%2C%20luxurious%20yet%20authentic%20atmosphere%2C%20no%20text%20no%20logos%20no%20labels%2C%20high-end%20editorial%20photography%20style&width=600&height=500&seq=pkg-exclusif-v2&orientation=portrait',
  },
];

export default function PricingSection() {
  const { t } = useTranslation();

  return (
    <section id="pricing" className="py-12 md:py-20 lg:py-28 px-4 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14 lg:mb-18">
          <div className="inline-flex items-center gap-3 md:gap-5">
            <span className="w-5 md:w-8 h-px bg-gradient-to-r from-transparent via-accent-400/50 to-accent-400/50"></span>
            <span className="text-[10px] md:text-xs tracking-[0.25em] uppercase text-accent-600 font-label font-semibold">
              {t('pricing.tag')}
            </span>
            <span className="w-5 md:w-8 h-px bg-gradient-to-l from-transparent via-accent-400/50 to-accent-400/50"></span>
          </div>

          <h2 className="mt-4 md:mt-6">
            <span className="block font-heading text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold text-foreground-900 leading-[0.95] tracking-tight">
              {t('pricing.heading_line1')}
            </span>
            <span className="block font-heading text-2xl sm:text-4xl md:text-5xl lg:text-6xl italic font-light text-foreground-600 leading-[1.1] mt-1 md:mt-1.5 tracking-tight">
              {t('pricing.heading_line2')}
            </span>
          </h2>

          <p className="mt-4 md:mt-6 text-xs md:text-sm text-foreground-400 font-body max-w-md mx-auto leading-relaxed">
            {t('pricing.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {packages.map((pkg) => (
            <div
              key={pkg.key}
              className="group relative rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-500 hover:scale-[1.02] hover:border-primary-200 cursor-pointer flex flex-col"
            >
              <div className="relative h-40 sm:h-48 md:h-56 overflow-hidden">
                <img
                  src={pkg.image}
                  alt={t(`pricing.${pkg.key}.title`)}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>
              </div>

              <div className="p-4 md:p-5 lg:p-6 flex flex-col flex-1">
                <h3 className="font-heading text-lg md:text-xl lg:text-2xl font-semibold text-foreground-900 leading-snug">
                  {t(`pricing.${pkg.key}.title`)}
                </h3>
                <p className={`text-base md:text-lg lg:text-xl font-heading font-bold mt-1 ${pkg.accent}`}>
                  {t(`pricing.${pkg.key}.price`)}
                </p>

                <ul className="mt-3 md:mt-4 space-y-2 md:space-y-2.5 flex-1">
                  {[1, 2, 3].map((f) => (
                    <li key={f} className="flex items-start gap-2 md:gap-2.5 text-xs md:text-sm text-foreground-600 font-body leading-snug">
                      <span className="w-4 h-4 md:w-5 md:h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-primary-500 text-xs md:text-sm"></i>
                      </span>
                      <span>{t(`pricing.${pkg.key}.feature${f}`)}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href="#booking"
                  className="mt-4 md:mt-5 inline-flex items-center justify-center gap-1.5 md:gap-2 w-full py-2 md:py-2.5 rounded-full bg-primary-500 text-white text-[11px] md:text-xs tracking-[0.1em] md:tracking-[0.12em] uppercase font-label font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {t('pricing.cta')}
                  <i className="ri-arrow-right-line text-xs"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}